import * as yup from 'yup';

const validation = yup.object({
	account: yup
		.string()
		.trim()
		.required('Username is required')
		.min(4, "Account's minimum length is 4")
		.max(20, "Account's maximum length is 20")
		.matches(
			/^[a-zA-Z][a-zA-Z0-9._]+$/,
			'Only alphabet, underscores dot and numbers are allowed',
		),
	password: yup
		.string()
		.required('password is required')
		.min(4, "Account's minimum length is 4")
		.max(20, "Account's maximum length is 20")
		.matches(/^[A-Za-z0-9_*]+$/, 'Only Alphabet and number are allowed.'),
	confirmPassword: yup
		.string()
		.required('password is required')
		.min(4, "Account's minimum length is 4")
		.max(20, "Account's maximum length is 20")
		.matches(/^[A-Za-z0-9_*]+$/, 'Only Alphabet and number are allowed.')
		.test({
			message: 'Password does not match',
			test: (value, ctx) => {
				if (value !== ctx.parent.password) {
					return false;
				}
				return true;
			},
		}),

	nickname: yup.string(),
	roleIds: yup.string().required('role is required'),
	remark: yup.string(),
});

export default validation;
